import "./TheLedger.module.css";
import MainNavigation from "@/reusable_sections/Header";
import FilmTelevision from "./sections/FilmTelevision";
import TheaterCredits from "./sections/TheaterCredits";
import DownloadOfficialCv from "./sections/DownloadOfficialCv";
import FooterArchive from "@/reusable_sections/Footer";
export default function TheLedgerPage() {
  return <div>
      <MainNavigation />
      <FilmTelevision />
      <TheaterCredits />
      <DownloadOfficialCv />
      <FooterArchive />
    </div>;
}